import axios from "axios";
import { https } from "../http";
import { showError } from "../utils";

// ─── Authenticated endpoints ──────────────────────────────────────────────────

export const requestSmsUpload = async (payload) => {
  try {
    const response = await https().post("/medication/sms-upload/request", payload);
    return response?.data;
  } catch (err) {
    showError(err?.response?.data?.message || "Failed to send SMS. Please try again.");
    throw err;
  }
};

export const getPendingSubmissions = async (clientId) => {
  try {
    const response = await https().get(`/medication/sms-upload/pending/${clientId}`);
    return response?.data?.data || [];
  } catch {
    return [];
  }
};

export const revokeUploadToken = async (tokenId) => {
  try {
    const response = await https().delete(`/medication/sms-upload/revoke/${tokenId}`);
    return response?.data;
  } catch (err) {
    showError(err?.response?.data?.message || "Failed to revoke link.");
    throw err;
  }
};

export const confirmPendingSubmission = async (submissionId) => {
  try {
    const response = await https().post(`/medication/sms-upload/confirm/${submissionId}`);
    return response?.data;
  } catch (err) {
    showError(err?.response?.data?.message || "Failed to confirm submission.");
    throw err;
  }
};

export const rejectPendingSubmission = async (submissionId) => {
  try {
    const response = await https().post(`/medication/sms-upload/reject/${submissionId}`);
    return response?.data;
  } catch (err) {
    showError(err?.response?.data?.message || "Failed to reject submission.");
    throw err;
  }
};

// ─── Public endpoints (no auth required) ─────────────────────────────────────
// Use require() lazily to avoid a circular-dependency TDZ error with http.js

const publicHttp = () => {
  const { baseURL } = require("../http");
  return axios.create({ baseURL });
};

export const verifyUploadToken = async (token) => {
  const response = await publicHttp().get(`/medication/sms-upload/verify?token=${token}`);
  return response?.data?.data;
};

export const submitUploadImages = async (token, formData) => {
  const response = await publicHttp().post(
    `/medication/sms-upload/submit?token=${token}`,
    formData,
  );
  return response?.data;
};
